import React from 'react';
import { Col, Layout, Row, Typography } from 'antd';
import dayjs from 'dayjs';
import { Input, Select, DatePicker } from 'components';
import { ReactComponent as IconInfo } from 'static/icons/info_blue.svg';
import { GENDER_OPTIONS_EN, GENDER_OPTIONS_ES, POB_OPTIONS } from './constants';
import './style.scss';
import { useLang } from '../PlayerRegistration';

const disabledDate = dayjs().subtract(8, 'year');

export const Step1 = () => {
  const { lang, t } = useLang();

  return (
    <Layout className="player-registration__step-1">
      <Row className="step-header">
        <Col span={24}>
          <Typography.Title level={4}>{t('subtitle_step_1')}</Typography.Title>
        </Col>
      </Row>
      <Row gutter={8} style={{ marginBottom: 16 }}>
        <Col span={24} md={{ flex: '33.33%' }}>
          <Input
            maxLength={20}
            name="first_name"
            label={t('label_first_name')}
            rules={[{ required: true, message: t('error_first_name') }]}
          />
        </Col>
        <Col span={24} md={{ flex: '33.33%' }}>
          <Input maxLength={1} name="middle_name" label={t('label_middle_name')} />
        </Col>
        <Col span={24} md={{ flex: '33.33%' }}>
          <Input
            maxLength={20}
            name="last_name"
            label={t('label_last_name')}
            rules={[{ required: true, message: t('error_last_name') }]}
          />
        </Col>
      </Row>
      <Row gutter={8}>
        <Col xs={24} md={{ flex: '104px' }}>
          <Select
            name="gender"
            label={t('label_gender')}
            rules={[{ required: true, message: t('error_gender') }]}
            options={lang === 'en' ? GENDER_OPTIONS_EN : GENDER_OPTIONS_ES}
            className="field-gender"
          />
        </Col>
        <Col xs={24} sm={{ flex: 'calc(100% - 128px)' }} md={{ flex: '232px' }}>
          <Select
            showSearch
            name="country"
            label={t('label_place_of_birth')}
            rules={[{ required: true, message: t('error_place_of_birth') }]}
            options={POB_OPTIONS}
          />
        </Col>
        <Col xs={24} md={{ flex: '120px' }}>
          <DatePicker
            name="birthdate"
            placeholder="MM/DD/YYYY"
            label={t('label_date_of_birth')}
            rules={[
              { required: true, message: t('error_date_of_birth') },
              {
                validator(_, value) {
                  const parsed = dayjs(value, 'DD/MM/YYYY', true);

                  if (value.length !== 10 || !parsed.isValid())
                    return Promise.reject(new Error(t('error_valid_date_of_birth')));
                  if (!parsed.isBefore(disabledDate)) return Promise.reject(new Error(t('error_min_8_years')));

                  return Promise.resolve();
                },
              },
            ]}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24} md={{ flex: '448px' }}>
          <div className="info-block">
            <IconInfo />
            <Typography.Text>{t('text_step_1_info')}</Typography.Text>
          </div>
        </Col>
      </Row>
    </Layout>
  );
};
